<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="4">
            <v-card-text>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    v-model="search_keyword"
                    label="Search ... "
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @keydown.enter="getData"
                    @change="page = 1"
                    @click:clear="(search_keyword = ''), getData()"
                  ></v-text-field>
                </v-col>
                <v-col sm="3">
                  <v-menu
                    v-model="month_menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="filter.month_year"
                        label="Year - Month"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        clearable
                        :error-messages="errors.month"
                        @click:clear="(filter.month_year = ''), getData()"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filter.month_year"
                      type="month"
                      @change="(month_menu = false), getData()"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col>
                  <v-autocomplete
                    v-model="filter.status"
                    :items="statusItems"
                    :label="`Status`"
                    clearable
                    @keydown.enter="getData"
                    @input="(page = 1), getData()"
                    @change="page = 1"
                    @click:clear="(filter.status = ''), getData()"
                    persistent-hint
                    prepend-icon="mdi-city"
                  >
                  </v-autocomplete>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <!-- / Filters -->
      <v-row>
        <v-col md="12">
          <v-card elevation="6">
            <!-- <v-card-title v-if="chats.length > 0"
              ><v-spacer></v-spacer> -->
            <!-- Download Excel -->
            <!-- <v-btn
                target="_blank"
                class="primary mx-4"
                :loading="isExcelloading"
                @click="generateExcel()"
              >
                Generate Excel</v-btn
              > -->
            <!-- </v-card-title> -->
            <v-progress-linear
              v-if="isLoading"
              indeterminate
              color="primary"
            ></v-progress-linear>
            <v-simple-table fixed-header>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">SR. NO.</th>
                    <th class="text-left" style="min-width: 150px">DATE</th>
                    <th class="text-left">Ticket Code</th>
                    <th class="text-left" style="min-width: 600px">Title</th>
                    <th class="text-left" min-width="400">CREATED BY</th>
                    <!-- <th class="text-left" style="min-width: 200px">TYPE</th> -->
                    <th class="text-left" style="min-width: 150px">STATUS</th>
                    <!-- <th class="text-left">IMAGES</th>
                    <th class="text-left" style="min-width: 130px">
                      FOLLOW UPS
                    </th> -->
                    <th class="text-left">ACTION</th>
                  </tr>
                </thead>
                <tbody v-if="chats.length != 0">
                  <tr v-for="(ticket, i) in chats" :key="`ticket${i}`">
                    <td style="min-width: 85px">
                      <v-tooltip bottom v-if="ticket.is_approved == 1">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            small
                            dark
                            color="green"
                          >
                            mdi-circle
                          </v-icon>
                        </template>
                        <span>Active</span>
                      </v-tooltip>
                      <v-tooltip bottom v-if="ticket.is_approved == 0">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            small
                            dark
                            color="red"
                          >
                            mdi-circle
                          </v-icon>
                        </template>
                        <span>In-Active</span>
                      </v-tooltip>
                      &nbsp;
                      {{ i + 1 }}
                    </td>
                    <td>
                      {{
                        ticket.created_at ? ticket.created_at.split(" ")[0] : ""
                      }}
                    </td>
                    <td>{{ ticket.ticket_code || "" }}</td>
                    <td>{{ ticket.title || "" }}</td>
                    <td>
                      {{ ticket.user ? ticket.user.first_name : "" }}
                    </td>
                    <!--<td>{{ ticket.type || "" }}</td>-->
                    <td>
                      <v-autocomplete
                        v-model="ticket.status"
                        :hint="'Select a status'"
                        :items="statusItems"
                        :label="`Status`"
                        @change="UpdateStatus(ticket)"
                        persistent-hint
                        prepend-icon="mdi-city"
                      >
                      </v-autocomplete>
                    </td>

                    <!-- <td>
                      <v-btn
                      v-if="ticket.image_path != null || ticket.image_path_2 != null || ticket.image_path_3 != null || ticket.image_path_4 != null"
                        class="text-caption px-1 py-1 rounded-lg"
                        color="success"
                        dark
                        @click="viewImage(ticket.id)"
                      >
                        view image
                      </v-btn>
                    </td> -->
                    <!-- <td>
                      <v-btn
                        class="mx-2"
                        fab
                        x-small
                        color="primary"
                        :to="`/chats/${ticket.id}/follow-ups`"
                      >
                        <v-icon dark> mdi-plus </v-icon>
                      </v-btn>
                    </td> -->
                    <td>
                      <v-btn
                        class="mx-2"
                        fab
                        x-small
                        color="primary"
                        @click="
                          getTicketDetails(ticket),
                            UpdateIsSeen(ticket),
                            (show_ticket_details = true)
                        "
                      >
                        <v-icon dark> mdi-eye </v-icon>
                      </v-btn>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="4"></td>
                    <td>
                      <v-pagination
                        class="float-right"
                        v-model="page"
                        :length="paginationLength"
                      >
                      </v-pagination>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr>
                    <td colspan="9" class="text-center">No data found</td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <!--End of Table -->
          </v-card>
        </v-col>
      </v-row>

      <v-dialog
        v-model="show_ticket_details"
        max-width="1000px"
        persistent
        scrollable
        transition="dialog-bottom-transition"
      >
        <v-card class="rounded-xl" style="background: #fefefe">
          <v-toolbar color="white" flat>
            <v-btn
              icon
              @click="
                show_ticket_details = false;
                ticket_detail.sent_to = 0;
                ticket_detail.ondc_code = null;
              "
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>
              <h3 class="font-weight-medium">{{ ticket_title }}</h3>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-switch
              v-if="selectedTicket.booking?.aggregator?.parent_id === 4"
              v-model="chatView"
              @change="getTicketDetails(selectedTicket)"
              :label="chatView ? 'ONDC CHAT' : 'USER CHAT'"
              class="ma-2"
              color="primary"
            ></v-switch>
          </v-toolbar>

          <v-divider></v-divider>

          <v-container class="pa-4" style="max-height: 600px; overflow-y: auto">
            <v-progress-linear
              v-if="isLoading"
              indeterminate
              color="primary"
            ></v-progress-linear>

            <template v-if="!isLoading">
              <v-row
                v-for="(ticket_detail, tD) in ticket_details"
                :key="tD"
                class="mb-3"
              >
                <v-col
                  :class="
                    ticket_detail.sender_id === user.id
                      ? 'text-right'
                      : 'text-left'
                  "
                >
                  <v-card
                    :color="
                      ticket_detail.sender_id === user.id
                        ? ticket_detail.sent_to === 2
                          ? 'blue lighten-1'
                          : 'green darken-1'
                        : ticket_detail.sent_by === 'IGM'
                        ? 'deep-purple lighten-2'
                        : 'blue-grey darken-1'
                    "
                    dark
                    class="pa-3 d-inline-block rounded-lg elevation-4"
                    style="max-width: 75%; word-wrap: break-word"
                  >
                    <v-card-text
                      class="white--text text-subtitle-1"
                      v-html="ticket_detail.description"
                    ></v-card-text>
                    <v-card-actions class="justify-end pa-0">
                      <v-icon small class="text-grey-lighten-2">
                        {{
                          ticket_detail.is_seen ? "mdi-check-all" : "mdi-check"
                        }}
                      </v-icon>
                      <span class="ml-2 text-caption text-grey-lighten-2">
                        {{ ticket_detail.created_at | in_days }}
                        {{ ticket_detail.created_at | HM }}
                      </span>
                    </v-card-actions>
                  </v-card>
                </v-col>
              </v-row>
            </template>
          </v-container>

          <v-divider></v-divider>

          <v-card-actions class="pa-4">
            <v-row class="w-100">
              <v-col cols="9">
                <vue-editor
                  v-model="message"
                  class="rounded-lg"
                  style="
                    min-height: 100px;
                    background: white;
                    border: 1px solid #ddd;
                  "
                />
              </v-col>

              <v-col cols="3">
                <v-select
                  v-if="chatView && !ticket_detail.ondc_code"
                  v-model="ticket_detail.ondc_code"
                  :items="OndcStatus"
                  label="ONDC Code"
                  solo
                  dense
                ></v-select>

                <v-btn
                  v-if="!chatView || (chatView && ticket_detail.ondc_code)"
                  :loading="isSending"
                  :disabled="isSending"
                  color="primary"
                  class="mt-3"
                  block
                  @click="sendMessage(ticket_details)"
                >
                  Send <v-icon right size="18">mdi-send</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog width="950" v-model="TicketsImageDialog">
        <v-carousel height="600" hide-delimiter-background show-arrows-on-hover>
          <v-carousel-item v-for="(slide, i) in slides" :key="i">
            <v-sheet height="100%">
              <v-row class="fill-height" align="center" justify="center">
                <v-img
                  :src="mediaUrl + slide"
                  contain
                  height="600"
                  max-width="950"
                />
              </v-row>
            </v-sheet>
          </v-carousel-item>
        </v-carousel>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
import { VueEditor } from "vue2-editor";
export default {
  components: {
    VueEditor,
  },
  name: "chatsPage",
  data() {
    return {
      filter: {
        month_year: "",
        month: "",
        year: "",
        expense_id: "",
      },
      chatView: false,
      items: [
        { text: "Send To User", value: 1 },
        { text: "Send To Ondc Partner", value: 2 },
      ],
      OndcStatus: [
        { text: "INFO_PROVIDED", value: "INFO_PROVIDED" },
        { text: "RESOLUTION_ACCEPTED", value: "RESOLUTION_ACCEPTED" },
        { text: "OPEN", value: "OPEN" },
      ],
      message: "",
      chats: [],
      ticket_details: [],

      statusItems: [
        { id: 1, text: "IN PROGRESS", value: 1 },
        { id: 2, text: "CLOSE", value: 2 },
        { id: 3, text: "PENDING", value: 0 },
      ],
      page: 1,
      serialNoStarting: 1,
      paginationLength: 0,
      selectedTicket: {},
      count: 0,
      search_keyword: "",
      show_ticket_details: false,
      ticket_detail: {
        sent_to: 0,
        ondc_code: null,
      },
      month_menu: false,
      isLoading: false,
      isExcelloading: false,
      TicketsImageDialog: false,
      isSending: false,
      slides: [],
      ticketId: "",
      isSeen: false,
      ticket_status: "",
      ticket_user_Id: "",
      ticket_title: "",
    };
  },
  watch: {
    chatView(newVal) {
      if (newVal == true) {
        this.ticket_detail.sent_to = 2;
      } else {
        this.ticket_detail.sent_to = 1;
      }
    },
    page: "getData",
    month_menu: "getMonthYear",
  },
  mounted() {
    console.log("logged in user", this.user.id);

    this.getData();
  },
  methods: {
    async getData() {
      this.isLoading = true;
      if (this.filter.month_year) {
        this.filter.year = this.filter.month_year.split("-")[0];
        this.filter.month = this.filter.month_year.split("-")[1];
      } else {
        this.filter.year = "";
        this.filter.month = "";
      }
      this.search_keyword = this.search_keyword ? this.search_keyword : "";
      this.filter.user_id = this.filter.user_id ? this.filter.user_id : "";
      this.filter.status =
        this.filter.status !== undefined ? this.filter.status : "";

      let query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.rowsPerPage +
        "&search_keyword=" +
        this.search_keyword +
        "&month=" +
        this.filter.month +
        "&year=" +
        this.filter.year +
        "&status=" +
        this.filter.status +
        "&user_id=" +
        this.filter.user_id;
      let response = await axios.get(`chats?${query}`);
      this.chats = response.data.data;
      this.count = response.data.count;
      this.serialNoStarting = (this.page - 1) * this.rowsPerPage;
      this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
      this.isLoading = false;
    },
    async generateExcel() {
      this.isExcelloading = true;
      this.search_keyword = this.search_keyword ? this.search_keyword : "";
      let query = "search_keyword=" + this.search_keyword;
      let response = await axios.get(`chats/export?${query}`);
      window.open(`${response.data.data}`, "_blank");
      this.isExcelloading = false;
      console.log(response);
    },
    getMonthYear() {
      if (this.filter.month_year) {
        this.filter.year = this.filter.month_year.split("-")[0];
        this.filter.month = this.filter.month_year.split("-")[1];
      }
    },
    viewImage(ticketId) {
      const ticket = this.chats.find((ticket) => ticket.id === ticketId);
      if (ticket) {
        // Extract image paths
        const imagePaths = [
          ticket.image_path,
          ticket.image_path_2,
          ticket.image_path_3,
          ticket.image_path_4,
        ];
        this.slides = imagePaths.filter((path) => path);
        this.TicketsImageDialog = true;
        console.log(this.slides);
      } else {
        console.log(`Ticket with ID ${ticketId} not found.`);
      }
    },
    async UpdateStatus(ticket) {
      console.log("chats", ticket.id);
      console.log("status", ticket.status);
      ticket.send_by_id = this.user.id;
      await axios.patch(`/chats/${ticket.id}`, ticket);
    },
    async sendMessage() {
      try {
        this.isSending = true;
        this.ticket_detail.ticket_id = this.ticketId;
        this.ticket_detail.description = this.message;
        this.ticket_detail.sender_id = this.user.id;
        this.ticket_detail.receiver_id = this.ticket_user_Id;
        // let ticket = this.ticket_details.filter((ticket) => ticket.id == this.ticketId)[0];
        let ticket = this.chats.find((ticket) => ticket.id == this.ticketId);

        if (ticket) {
          this.ticket_detail.booking_id = ticket.booking_id;
        } else {
          console.error("Ticket not found");
        }

        console.log("ticket_detail", this.ticket_detail);

        let response = await axios.post("/ticket_details", this.ticket_detail);
        console.log("response", response);

        if (response) {
          let detail = response.data.data;
          this.ticket_details.push(detail);
          this.isSending = false;
          this.message = "";
          this.ticket_detail.ondc_code = null;
        }
        this.$refs.chatBody.scrollTop = this.$refs.chatBody.scrollHeight;
      } catch (e) {
        console.log(e);
        this.isSending = false;
      }
    },
    async getTicketDetails(ticket) {
      console.log("this.ticketId", this.ticketId);

      this.isLoading = true;
      this.isSeen = true;
      this.ticketId = ticket.id;
      this.ticket_user_Id = ticket.user_id;
      this.ticket_status = ticket.status;
      this.ticket_title = ticket.title;
      this.selectedTicket = ticket;
      let query =
        "ticket_id=" +
        ticket.id +
        "&is_admin=true" +
        "&ondc_chat=" +
        this.chatView;
      let response = await axios.get(`/ticket_details?${query}`);
      this.ticket_details = response.data.data;
      console.log("ticket_details", this.ticket_details);

      this.isLoading = false;
    },
    async UpdateIsSeen(ticket) {
      console.log("ticket IsSeen ", ticket);
      this.isLoading = true;
      let query = "ticket_id=" + ticket.id + "&user_id=" + this.user.id;
      console.log("qury ", query);
      let response = await axios.get(`/ticket_details/updateStatus?${query}`);
      console.log("updateStatus", response);

      this.isLoading = false;
    },
  },
};
</script>
<style scoped>
.chat-bubble {
  border-radius: 18px;
  padding: 10px;
  background: linear-gradient(to right, #4caf50, #388e3c);
  box-shadow: 2px 4px 10px rgba(0, 0, 0, 0.2);
  position: relative;
}

.bubble-tail {
  position: absolute;
  bottom: -8px;
  right: 12px;
  width: 16px;
  height: 16px;
  background: #689f38;
  clip-path: polygon(100% 0, 0 0, 50% 100%);
}
.bubble-tail-ondc {
  position: absolute;
  bottom: -8px;
  right: 12px;
  width: 16px;
  height: 16px;
  background: linear-gradient(to right, #42a5f5, #42a5f5);
  clip-path: polygon(100% 0, 0 0, 50% 100%);
}

.left-chat-bubble {
  border-radius: 18px;
  padding: 10px;
  background: linear-gradient(to right, #546e7a, #455a64);
  box-shadow: 2px 4px 10px rgba(0, 0, 0, 0.2);
  position: relative;
}

.bubble-tail-left {
  position: absolute;
  bottom: -8px;
  left: 12px;
  width: 16px;
  height: 16px;
  background: #546e7a;
  clip-path: polygon(100% 0, 0 0, 50% 100%);
}
.bubble-tail-left_ondc {
  position: absolute;
  bottom: -8px;
  left: 12px;
  width: 16px;
  height: 16px;
  background: linear-gradient(to right, #9575cd, #9575cd);
  clip-path: polygon(100% 0, 0 0, 50% 100%);
}
</style>
